import P from "prop-types";
import * as S from "../styles";

import { HorizontalBarChartCard } from "../../ChartCards/HorizontalBarChartCard";
import { useAxios } from "../../../../../hooks/useAxiosMobile";

export function Proporcoes({ currentIndex, queryState }) {
  const chartStyle = {
    height: "100%",
    width: "100%",
    display: 'flex',
    alignItems: "center",
    justifyContent: "center",
  };



  let uri = `/api/mobile/proporcao_sentimentos/?uf=${queryState}`;
  const { loading, error, response } = useAxios({
    method: "GET",
    url: uri,
    headers: {
      accept: "*/*",
    },
  });
  

  if(currentIndex!==1){
    return(<></>)
  }
  return (
    <S.Container>
      <S.Container2>

        <HorizontalBarChartCard
          title="Proporção geral dos sentimentos"
          dados={response && response.dados.length > 0 ? response.dados : response}
          error={error}
          style={chartStyle}
          loading={loading}
        />


      </S.Container2>
    </S.Container>
  );
}

Proporcoes.propTypes = {
  currentIndex: P.number.isRequired,
};
